module.exports = __webpack_public_path__ + "img/icon_password_setting_selected.67e75358.svg";